<template>
  <SListItem :title="editedByName || authorName"
             :datetime="absence.updated_at"
             datetime-format="dateTime"
             :badges="getBadges"
  >
    <template #description>
      <span class="sdui-list-item__description nano text-muted d-flex flex-column">
        <absence-duration-description :absence="absence" />
        <p class="d-flex mb-0">{{ absence.comment }}</p>
      </span>
    </template>
  </SListItem>
</template>

<script>
import absenceStatusMixin from 'src/mixins/classbook/absenceStatusMixin.js'
import classbookStatusFlagMixin from 'src/mixins/classbook/classbookStatusFlagMixin.js'

import AbsenceDurationDescription from 'src/components/classbook/absences/AbsenceDurationDescription.vue'

export default {
  name: 'UserAbsenceHistoryItem',
  components: { AbsenceDurationDescription },
  mixins: [absenceStatusMixin, classbookStatusFlagMixin],
  props: {
    absence: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    authorName() {
      return this.absence.author?.meta?.displayname
    },

    editedByName() {
      return this.absence.edited_by?.meta?.displayname
    },

    getBadges() {
      if (!this.absence) return []

      const badges = []
      badges.push(this.getAbsenceStateBadgeByAbsence(this.absence))
      if (this.absenceState) badges.push(this.getClassbookStatusBadge(this.statusFlagTitle, this.absenceState))
      return badges
    },
  },
}
</script>
